<section class="header">
  <div class="title">Export fields</div>
  <button class="close-button" mat-icon-button (click)="dismiss()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</section>

<section class="body">
  <section class="user-feedback">
    <app-alert-banner [type]="'info'">
      <p>Please select the object type you wish to export its related fields.</p>
      <p>After clicking <strong>Export</strong>, a <strong>csv</strong> file format will be generated.</p>
    </app-alert-banner>
  </section>

  <form [formGroup]="importableFieldsForm">
    <section class="export-fields">
      <!-- Object Type -->
      <mat-form-field class="w-full">
        <mat-label>Object type:</mat-label>
        <mat-select [formControlName]="'object_type'" [disableOptionCentering]="true" required>
          <input class="ts-select-search-input" [formControl]="importEnableObjectsCtrl" [placeholder]="'Search...'" />
          <mat-option *ngIf="!filteredImportableObjects?.length" disabled>No matches found</mat-option>
          <mat-option *ngFor="let object of filteredImportableObjects" [value]="object.name">
            {{ object.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </section>
    <section class="button-actions">
      <button mat-stroked-button (click)="dismiss()">Cancel</button>
      <button
        mat-raised-button
        [color]="'primary'"
        [disabled]="importableFieldsForm.invalid"
        class="ml-4"
        DebounceClick
        (debounceClick)="exportFields()"
      >
        <ng-container *ngIf="!isLoading; else loadingState"> Export</ng-container>
      </button>
    </section>
  </form>
</section>

<ng-template #loadingState>
  <mat-spinner diameter="24" [strokeWidth]="2" [mode]="'indeterminate'" [color]="'primary'"></mat-spinner>
</ng-template>
